import { useMemo } from "react";

import ApiService, { ApiServiceParams, IApiService } from "./api-service";
import { createSocketService, ISocketService } from "./socket-service";

export const useApi = (config: ApiServiceParams): IApiService => useMemo(() => new ApiService(config), [config]);

export const useGetSocket = (uri: string, appKey: string, broadcastToken: string): ISocketService =>
  useMemo(() => {
    return createSocketService(uri, appKey, broadcastToken);
  }, [uri, appKey, broadcastToken]);

export { ApiServiceError, type IApiServiceError } from "./altius-api-error";
export * from "./socket-service";
export * from "./socket-singleton";
export * from "./api-service";
